import React, { useEffect, useState } from "react";
import Logo from "../../assets/Logo.png";
import "./DownloadTheApp.css";
import ErrModal from "./modals/ErrModal";
import iphoneGuide from "../../assets/iphoneGuide.png";

export default function DownloadTheApp({
  isInstallable,
  isStandalone,
  handleInstallClick,
}) {
  const [errModal, setErrModal] = useState(false);
  const [isIos, setIsIos] = useState(false);

  useEffect(() => {
    if (/iPhone|iPad|iPod/.test(navigator.userAgent)) {
      setIsIos(true);
    }
  }, []);
  const cancelModal = () => {
    setErrModal(false);
  };

  const handleClick = () => {
    if (isInstallable && !isStandalone) {
      handleInstallClick();
    } else {
      setErrModal(true);
    }
  };
  return (
    <div className="container bg-white text-center">
      <div className="blueBanner text-center fw-bold p-2">Download The App</div>
      {isIos ? (
        <div>
          <img
            src={iphoneGuide}
            className="w-75"
            alt="Membotic - All your fitness clubs and activities together"
            title="Membotic - All your fitness clubs and activities together"
          />

          <p>Press the share icon and then press Add to Home Screen.</p>
        </div>
      ) : (
        <div>    <p>Click the icon to download the app.</p>
        <div>
          <img
            onClick={handleClick}
            src={Logo}
            className="app-icon pointer"
            alt="Membotic - All your fitness clubs and activities together"
            title="Membotic - All your fitness clubs and activities together"
          />
          <br />
          <p>If you encounter issues with the download, try using Chrome.</p>
        </div></div>
      )}

  

      {errModal && <ErrModal cancelModal={cancelModal} />}
    </div>
  );
}
